import { Injectable } from '@angular/core';
import { CRUDService } from '../../core/services/crud.service';
import { Stock } from '../entities/stock';

@Injectable({
  providedIn: 'root'
})
export class StockService extends CRUDService<Stock> {

  getClassName(): string {
    return "StockService";
  }

  findById(id: number) {
    return this.httpInt.get(`${this.end_point}findById/${id}`);
  }

  // Método con typo mantenido para compatibilidad
  finById(id: number) {
    return this.findById(id);
  }

  findByIdInventario(id: number) {
    return this.httpInt.get(`${this.end_point}findByIdInventario/${id}`);
  }

}
